import { render, staticRenderFns } from "./inventory-report.vue?vue&type=template&id=0cd58beb&"
import script from "./inventory-report.vue?vue&type=script&lang=ts&"
export * from "./inventory-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports